import { addDays, format } from 'date-fns'
import { useWorkdayExceptions } from './time-queries'
import { periodLabel, vacationRange } from './vacation'
import { weekMetaFromId } from './week'

/**
 * De aaneengesloten vakantieperiode rond een dag, met de uitzondering-ids die nodig
 * zijn om hem in een keer te verwijderen. Het venster is op de week verankerd zodat
 * alle dagen van dezelfde week dezelfde query delen.
 */
export function useVacationPeriod(weekId: string, personId: string | undefined, dayIso: string, enabled: boolean) {
  const meta = weekMetaFromId(weekId)
  const from = format(addDays(meta.days[0].date, -35), 'yyyy-MM-dd')
  const to = format(addDays(meta.days[6].date, 35), 'yyyy-MM-dd')
  const query = useWorkdayExceptions(from, to, personId, enabled)

  const byDate = new Map(
    (query.data ?? []).filter((e) => e.kind === 'VACATION').map((e) => [e.date, e.id]),
  )
  const dates = vacationRange(new Set(byDate.keys()), dayIso, from, to)
  const ids = dates.map((date) => byDate.get(date)).filter((id): id is string => id !== undefined)

  // Zolang de uitzonderingen nog binnenkomen ziet elke dag eruit als een losse
  // vakantiedag. Verwijderen mag dan nog niet: wie doorklikt zou een dag uit een
  // reeks halen terwijl hij de hele reeks bedoelde.
  return { dates, ids, label: dates.length > 1 ? periodLabel(dates) : null, loading: query.isLoading }
}
